import { FC } from 'react';

import { ActionVariants } from '@formstack/phoenix/components/actionVariants/constants';

import { ConfirmationDialog } from '@/common/components/ConfirmationDialog';
import { FSID_BILLING_URL } from '@/common/constants';
import { useResource } from '@/common/resources';
import { pendoTrack } from '@/common/utils/pendo';

import { IBaseDialog } from '../interface';

export const MissingProductConnectorDialog: FC<IBaseDialog> = ({ onCancel }) => {
  const { heading, message, confirmLabel } = useResource((resource) => ({
    ...resource.MISSING_PRODUCT_CONNECTOR_DIALOG_RESOURCES,
    confirmLabel: resource.goToAdmin,
  }));

  const onConfirm = () => {
    pendoTrack('Missing Product - Redirecting to billing');
    window.open(FSID_BILLING_URL, '_blank');
    onCancel?.();
  };

  return (
    <ConfirmationDialog
      data-test="missing-product-connector-dialog"
      heading={heading}
      message={message}
      confirmLabel={confirmLabel}
      confirmationVariant={ActionVariants.link}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
};
